// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__Lx+1E","timeBlock":"mimic___styles_timeBlock__w6N8+"};